import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let heroesHeight = document.querySelectorAll('.noss_hero.include-header[class*=" sizing-"]');
    if (heroesHeight.length) {
        for (let i = 0; i < heroesHeight.length; ++i) {
            let currentHeight = heroesHeight[i].offsetHeight + 'px';
            heroesHeight[i].style.setProperty('height', 'calc(' + currentHeight + ' - var(--paws-header-height))', 'important');
        }
    }

    let heroesHeightMin = document.querySelectorAll('.noss_hero.include-header[class*=" min-sizing-"]');
    if (heroesHeightMin.length) {
        for (let i = 0; i < heroesHeightMin.length; ++i) {
            let currentHeight = heroesHeightMin[i].offsetHeight + 'px';
            heroesHeightMin[i].style.setProperty('min-height', 'calc(' + currentHeight + ' - var(--paws-header-height))', 'important');
        }
    }

    let heroesHeightMax = document.querySelectorAll('.noss_hero.include-header[class*=" max-sizing-"]');
    if (heroesHeightMax.length) {
        for (let i = 0; i < heroesHeightMax.length; ++i) {
            let currentHeight = heroesHeightMax[i].offsetHeight + 'px';
            heroesHeightMax[i].style.setProperty('max-height', 'calc(' + currentHeight + ' - var(--paws-header-height))', 'important');
        }
    }

}